<template>
  <rj-layout :menu-list="showMenuList" @customer-call="showCustomerCall">
    <div slot="headerTitle" class="headerTitle">
      CES
    </div>
    <div slot="header-right" class="rj-main-rigth-message">
      <div class="cusService download" @click="downOperator">
        <i class="iconfont el-icon-s-claim" />
        下载ces操作文档
      </div>
      <a ref="down" href="/CES系统操作指南.pdf" target="_blank" />
      <div class="cusService">
        <i class="iconfont iconphone" />
        技术支持：飞书搜索【IT技术支持】
      </div>
      <!-- <div class="contact">
        <i class="iconfont iconphone" />
        联系我们
        <span class="qiyukf" @click="openQiyukf" />
      </div> -->
      <div class="cusService user-wrap">
        <i class="iconfont iconphone" />
        业务支持：13609593772
      </div>
      <div class="userName">
        {{ username }} {{ signType }}
      </div>
      <div class="logOut" @click="loginOut">
        <i class="iconfont iconlog_out" />
        退出
      </div>
    </div>
    <div class="rj-main-router-page">
      <keep-alive :include="['ChiefOrderList', 'DistributorOrderList']">
        <router-view />
      </keep-alive>
    </div>
  </rj-layout>
</template>

<script>
import layout from '../components/layout';
import { layoutRoute } from '@/router/router';
import Cookies from 'js-cookies';
import { mapState } from 'vuex';
import qiyukf from '@/libs/qiyukf';

export default {
  components: {
    'rj-layout': layout
  },

  data () {
    return {
      username: '',
      signType: '',
      layoutRoute
    };
  },

  computed: {
    isTxt () {
      if (this.$route.path === '/') return true;
      return false;
    },
    showMenuList () {
      if (!this.$store.state.user) {
        return [];
      }
      const menuList = layoutRoute.map((main) => {
        const mainItem = {
          ...main,
          meta: main.meta ? { ...main.meta } : {},
          children: (main.children || []).map((router) => ({
            ...router,
            meta: router.meta ? { ...router.meta } : {}
          }))
        };
        let hiddenLength = 0;
        // 强制显示的白名单：不受权限码控制
        const forceShowList = ['orderInternationPersionContractList', 'creditTransfer', 'settlementQuery', 'invoiceNoticeManagement', 'orderClerkWireTransferAllocation'];
        mainItem.children.forEach((router) => {
          if (forceShowList.indexOf(router.name) >= 0) {
            router.hidden = false;
            return;
          }
          if (this.$store.state.user.perssimionCodeList.indexOf(router.name) < 0) {
            router.hidden = true;
            hiddenLength++;
          } else {
            if (this.$store.state.user.isDistributors === 1 && router.name === 'ChiefOrderList') {
              router.hidden = true;
              hiddenLength++;
            }
            if (this.$store.state.user.isDistributors === 2 && router.name === 'DistributorOrderList') {
              router.hidden = true;
              hiddenLength++;
            }
            if (this.$store.state.user.isDistributors === 0 && (router.name === 'ChiefOrderList' || router.name === 'DistributorOrderList')) {
              router.hidden = true;
              hiddenLength++;
            }
          }
        });
        if (hiddenLength === mainItem.children.length) {
          mainItem.hidden = true;
        }
        return mainItem;
      });
      const autoRebateMenus = this.normalizeAutoRebateMenus(this.$store.state.autoRebateMenuList);
      return [...menuList, ...autoRebateMenus];
    },
    ...mapState({
      user: state => state.user,
      autoRebateMenuList: state => state.autoRebateMenuList
    })
  },

  watch: {
    '$route.path' (newVal) {
      if (newVal === '/toLoginPage') qiyukf.logoff();
    }
  },

  mounted () {
    this.username = this.user.userName;
    this.signType = this.user.signType;
    qiyukf.init(() => {
      qiyukf.setConfig(this.user);
    });
  },

  methods: {
    normalizeAutoRebateMenus (menuList = []) {
      return menuList
        .filter((item) => item && item.isShow === '1')
        .sort((first, second) => Number(first.sort || 0) - Number(second.sort || 0))
        .map((item) => {
          const children = this.normalizeAutoRebateMenus(item.children || []);
          const href = item.href && item.href.startsWith('/')
            ? `${window.location.origin}/autoRebate${item.href}`
            : `${window.location.origin}/autoRebate/${item.id}`;
          return {
            path: href,
            name: `autoRebate-${item.id}`,
            target: '_self',
            alwaysShow: children.length > 0,
            hidden: item.isShow !== '1',
            meta: {
              title: item.name,
              icon: item.icon || ''
            },
            children
          };
        })
        .filter((item) => item.children.length || item.path);
    },
    showCustomerCall () {
    },
    changeUser () {
      this.$router.push({ name: 'changeUser' });
    },
    loginOut () {
      this.$confirm('是否退出该系统?', '提示', {
        confirmButtonText: '退出',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        Cookies.removeItem('ruijieportal', '/', '.ruijie.com.cn');
        Cookies.removeItem('PartnerUser', '/', '.ruijie.com.cn');
        Cookies.removeItem('phplogin', '/', '.ruijie.com.cn');
        Cookies.removeItem('thh_auth', '/', '.ruijie.com.cn');
        Cookies.removeItem('sid_login', '/', '.ruijie.com.cn');
        // 干掉切换的渠道
        Cookies.removeItem('xsyx_chang_user', '/', '.ruijie.com.cn');
        this.$message({
          type: 'success',
          message: '退出成功!'
        });
        // 推出会话登录
        window.localStorage.removeItem('union_session_ticket');
        window.localStorage.removeItem('loginType');
        if (window._env_.NODE_ENV !== 'pro') {
          window.location.href = `https://sid.ruijie.com.cn/logout?service=${
            encodeURIComponent(window.location.origin)
          }/toLoginPage`;
        } else {
          // window.location.href = `https://ces.ruijie.com.cn/toLoginPage`;
          window.location.href = `https://sid.ruijie.com.cn/logout?service=${
            encodeURIComponent(window.location.origin)
          }/toLoginPage`;
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消退出'
        });
      });
    },
    downOperator () {
      this.$refs.down.click();
    },

    openQiyukf () {
      qiyukf.openSdk();
    }
  }
};
</script>

<style lang="scss">
  @import "../style/var";
  .headerTitle{
    line-height: 58px;
    padding-left: 30px;
    font-size: 16px;
    font-weight: bold;
    color: $--color-text-primary;
  }
  @include namespace(main-rigth-message){
    line-height: $layoutHeaderHeight;
    margin-right: 10px;
    max-width: calc(100vw - 330px);
    white-space: nowrap;
    overflow-x: auto;
    &::-webkit-scrollbar{
      height: 5px;
      background: #ddd;
    }
    &::-webkit-scrollbar-thumb{
      background-color: #ccc;
      border-radius: 4px;
    }
    div{
      display: inline-block;
      margin-right: 20px;
    }
    i{
      margin-right: 6px;
    }
    .cusService{
      margin-right: 50px;
      &.download:hover{
        color: #409EFF;
      }
    }
    .logOut{
      color: $primaryColor;
      cursor: pointer;
    }
  }
  @include namespace(main-router-page){
    padding: 15px;
  }
  .el-button{
    white-space: inherit;
  }

</style>

<style lang="scss" scoped>
.contact{
    margin-right: 0 !important;
    padding-right: 70px;
    position: relative;

    .qiyukf {
      position: absolute;
      top: 8px;
      right: 10px;
      display: inline-block;
      width: 50px;
      height: 34px;
      background: url(../assets/orderCustomer.png) no-repeat;
      background-size: cover;
      cursor: pointer;
    }
}
</style>
